import { useEffect } from "react";
import { TDragState } from "../app/store";
import { useSharedState } from "../app/useSharedState";
// import { MouseEvent } from "react";

type PointerEventUnion = PointerEvent | React.PointerEvent;

const STYLE_ELEMENT_ID = "cursor-override-style";

const noop = (e: PointerEventUnion) => {};
let activeCallback: (e: PointerEventUnion) => void = noop;

document.addEventListener("pointermove", (e) => {
  activeCallback(e);
});

export function useOnDrag(
  dragState: TDragState | null,
  // If useOnDrag is called while active due to a rerender, the current callback will continue to be active until mouseup
  // Then, on the next mousedown, the latest one will be used
  callback: (
    e: PointerEventUnion,
    origin: readonly [number, number],
    displacement: readonly [number, number]
  ) => void,
  cursor?: string,
  minDistance?: number,
  allowOnTextInput?: boolean
) {
  cursor = undefined;

  const [activeState, setActiveState] = useSharedState("dragState");

  const onPointerDown = (event: PointerEventUnion) => {
    // if (isEditingTextInput() && !allowOnTextInput) {
    //   return;
    // }

    const origin = [event.clientX, event.clientY] as const;
    const startDrag = () => {
      if (cursor) {
        const styleElement = document.createElement("style");
        styleElement.id = STYLE_ELEMENT_ID;
        // styleElement.innerHTML = `* { cursor: ${cursor} !important; }`;
        styleElement.innerHTML = `body { cursor: ${cursor} !important; }`;
        document.head.appendChild(styleElement);
      }
      setActiveState(dragState);
      activeCallback = (e: PointerEventUnion) => {
        callback(e, origin, [e.clientX - origin[0], e.clientY - origin[1]]);
      };
      activeCallback(event);
    };

    if (minDistance && minDistance > 0) {
      activeCallback = (e: PointerEventUnion) => {
        const distSq =
          (origin[0] - e.clientX) ** 2 + (origin[1] - e.clientY) ** 2;
        if (distSq > minDistance * minDistance) {
          startDrag();
        }
      };
    } else {
      startDrag();
    }
  };

  const onPointerUp = (e: PointerEvent) => {
    activeCallback = noop;
    if (activeState !== null) {
      // e.stopPropagation();
      setActiveState(null);
      const styleElement = document.getElementById(STYLE_ELEMENT_ID);
      if (styleElement) {
        document.head.removeChild(styleElement);
      }
    }
  };

  useEffect(() => {
    document.addEventListener("pointerup", onPointerUp);
    return () => {
      document.removeEventListener("pointerup", onPointerUp);
    };
    // }, [callback]);
  });

  return [onPointerDown, activeState] as const;
}
